import "./UIButton.css"
import React from 'react'
import classnames from "classnames"
import Window from "./Window"

const UIButton = ({ children, onClick, disabled, ...props})=> {
  const className = classnames("UIButton", props.className, { "UIButton--disabled": disabled })
  return <Window className={className} {...props} onClick={onClick}>
    { children }
  </Window>
}

UIButton.defaultProps = {
  backgroundColor: "#000",
  borderColor: "#3c8aba",
  width: 200,
  height: 60,
  cornerWidth: 20,
}

export default UIButton


// WEBPACK FOOTER //
// ./src/components/UIButton.js